var map = {
	"./asthma.png": "860a",
	"./cashier_pocket_edition_poster.jpg": "eb2e",
	"./document signing verification.png": "e200",
	"./give.png": "a849",
	"./linemanwongnai.jpg": "8b26",
	"./micro.jpg": "08e4",
	"./pitching.jpg": "1a1e",
	"./se.png": "b316",
	"./stock.png": "ebdb",
	"./topgun.jpg": "6986",
	"./unity.jpg": "c177",
	"./word-card-app.png": "b1a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc1f";